const DEBUG_EVENT_NAME = "neuronDebugUpdate";
const MAX_BATCH_ENTRIES = 25;
const DEBUG_STORAGE_KEY = "neuron:debugState";

const DEFAULT_DEBUG_STATE = {
  sessionId: null,
  requestId: null,
  batchRequests: [],
  latestRecommendation: null,
};

const readPersistedDebugState = () => {
  if (typeof window === "undefined") {
    return DEFAULT_DEBUG_STATE;
  }

  try {
    const stored = window.localStorage.getItem(DEBUG_STORAGE_KEY);
    if (!stored) {
      return DEFAULT_DEBUG_STATE;
    }

    const parsed = JSON.parse(stored);
    return {
      ...DEFAULT_DEBUG_STATE,
      ...parsed,
      batchRequests: Array.isArray(parsed?.batchRequests)
        ? parsed.batchRequests
        : [],
    };
  } catch (error) {
    return DEFAULT_DEBUG_STATE;
  }
};

let debugState = readPersistedDebugState();

const persistDebugState = () => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(DEBUG_STORAGE_KEY, JSON.stringify(debugState));
  } catch (error) {
    // Ignore persistence failures for debug state.
  }
};

const notifyDebugListeners = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(DEBUG_EVENT_NAME, {
      detail: debugState,
    })
  );
};

export const getNeuronDebugState = () => debugState;

export const updateNeuronDebugState = (partial) => {
  debugState = {
    ...debugState,
    ...partial,
  };

  persistDebugState();
  notifyDebugListeners();
};

export const appendNeuronBatchRequest = (entry) => {
  const nextBatchRequests = [entry, ...debugState.batchRequests].slice(
    0,
    MAX_BATCH_ENTRIES
  );

  debugState = {
    ...debugState,
    batchRequests: nextBatchRequests,
  };

  persistDebugState();
  notifyDebugListeners();
};

export const NEURON_DEBUG_EVENT_NAME = DEBUG_EVENT_NAME;
